/**
 * @module DynamicButton
 * @description
 */
import React, { FC } from "react";
import { useContext } from "react";
import dynamic from "next/dynamic";
import { FeatureFlagContext } from "ui/providers/feature-flagging";

const PhoneButton = dynamic(() => import("./PhoneButton"), { ssr: false });
const CartButton = dynamic(() => import("./CartButton"), { ssr: false });
const LinkButton = dynamic(() => import("./LinkButton"), { ssr: false });

interface Props {
  type?: "link" | "phone" | "cart";
  title?: string;
  href?: string;
  position?: string;
  className?: string;
  showIcon?: boolean;
  theme?: "red" | "white" | "dark" | "dark-outline" | "tertiary-dark";
  children?: JSX.Element;
  productId?: string;
}

const DynamicButton: FC<Props> = ({ ...props }) => {
  const { phoneHeavy, cartHeavy } = useContext(FeatureFlagContext);
  const { type = "link" } = props;

  // Phone && Cart
  if (type === "phone" || type === "cart") {
    if (phoneHeavy === false && cartHeavy === true && type === "phone") {
      // phoneHeavy is off, cartHeavy is on, update phone buttons
      return <CartButton {...props} />;
    }
    if (phoneHeavy === true && cartHeavy === false && type === "cart") {
      // cartHeavy is off, phoneHeavy is on, update cart buttons
      return <PhoneButton {...props} />;
    }

    if (type === "phone") {
      return <PhoneButton {...props} />;
    }

    return <CartButton {...props} />;
  }

  // Default Case
  return (
    <>
      <LinkButton {...props} />
    </>
  );
};

DynamicButton.displayName = "DynamicButton";

export default DynamicButton;
